"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    studentsStandardsDetails: {
        title: 'Students Details',
        performanceAriaLabel: 'Standard {{standardLabel}}, scored with {{percentage}} as {{proficiency}}',
    },
};
